<template>
  <v-page>
    <v-link to="/me/my-content">
      <toolbar class="mb-3" :logo="false">
        <template v-slot:left>
          <span class="v-toolbar__text">
            {{ product ? product.title : "Loading..." }}
          </span>
        </template>
      </toolbar>
    </v-link>

    <template v-if="product && product.has_given_app_access">
      <div class="container p-2 text-center">
        <h4 class="my-0">
          This purchase gives you access <br />
          to all content included in the app <br />
          subscription
        </h4>
      </div>
    </template>

    <template v-else>
      <collection
        :space-bottom-ratio="225"
        card-display="horizontal"
        :items="purchasedPages"
        :show-price="false"
        unlock
      >
      </collection>
    </template>

    <list boxed heading="Payments" class="mt-2">
      <list-item chevron @click="() => $router.push('/me/account/purchases')">
        <template slot="left">
          <v-icon icon="attach_money" />
        </template>
        <div class="v-list-item__title --centered ml-1">
          View purchase history
        </div>
      </list-item>
    </list>
  </v-page>
</template>

<script>
import { mapActions } from "vuex"

import Collection from "@/components/Collection"
import Toolbar from "@/components/Toolbar"
import List from "@/components/List"
import ListItem from "@/components/ListItem"

export default {
  components: {
    Collection,
    Toolbar,
    List,
    ListItem
  },

  mounted() {
    this.isLoading = true
    this.fetchPurchasedItems(this.productId)
      .then(({ product, purchased_pages }) => {
        this.product = product
        this.purchasedPages = purchased_pages
      })
      .finally(() => {
        this.isLoading = false
      })
  },

  data() {
    return {
      product: null,
      purchasedPages: [],
      isLoading: false
    }
  },

  computed: {
    productId() {
      return this.$route.params.id
    }
  },

  methods: {
    ...mapActions("products", ["fetchPurchasedItems"])
  }
}
</script>
